import * as React from "react"

const PointsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M4 4h1v1H4zm7 7h1v1h-1zm-7 0h1v1H4zm-1 1h1v1H3zm9 0h1v1h-1zm0-9h1v1h-1zM3 3h1v1H3zm8 1h1v1h-1zM7.5 5.5h1v1h-1zm0-1h1v1h-1zm0-1h1v1h-1zm2 4h1v1h-1zm1 0h1v1h-1zm1 0h1v1h-1zm-6 0h1v1h-1zm-1 0h1v1h-1zm-1 0h1v1h-1zm4 2h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm-1-5h1v1h-1zm2 0h1v1h-1zm-2 2h1v1h-1zm2 0h1v1h-1z" />
  </svg>
)

export default PointsIcon
